import * as Yup from 'yup';

const PinSchema = Yup.object().shape({
  instruction: Yup.string().required('Adicione alguma instrução'),
  pins: Yup.array().min(1, 'Adicione um arquivo com pins'),
  qt_limit: Yup.number().when('buy_limit', {
    is: true,
    then: Yup.number().required('Informe a quantidade limite').min(1, 'Limite de compra deve ser pelo menos 1'),
  }),
  qt_notify: Yup.number().when('qt_warning', {
    is: true,
    then: Yup.number().required('Informe a quantidade').min(1, 'Quantidade mínima para aviso deve ser pelo menos 1'),
  }),
});

export default PinSchema;
